import TicketCard from "./TicketCard";
import type { ZammadUserTicket } from "@/mocks/zammadTickets";

interface TicketListProps {
  tickets: ZammadUserTicket[];
  onTicketClick: (ticket: ZammadUserTicket) => void;
}

export default function TicketList({ tickets, onTicketClick }: TicketListProps) {
  if (tickets.length === 0) {
    return (
      <div className="rounded-xl bg-background-50 border border-background-200/80 p-10 text-center">
        <div className="w-14 h-14 mx-auto mb-3 rounded-full bg-background-100 flex items-center justify-center">
          <i className="ri-file-list-3-line text-foreground-400 text-xl"></i>
        </div>
        <h4 className="text-sm font-semibold text-foreground-700 mb-1">Sin tickets</h4>
        <p className="text-xs text-foreground-500 max-w-xs mx-auto">
          No se encontraron tickets con los filtros seleccionados.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {tickets.map((ticket) => (
        <TicketCard
          key={ticket.id}
          ticket={ticket}
          onClick={onTicketClick}
        />
      ))}
    </div>
  );
}